import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import * as S from './styles';
import Subtitle from './Subtitle';

export type NavigatableHeaderProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  button?: React.ReactNode;
};

const NavigatableHeader: React.FC<NavigatableHeaderProps> = ({
  title,
  subtitle,
  button,
}): React.ReactElement => (
  <Spacer orientation="horizontal" align="center">
    <S.Spacer>
      <S.Title>{title}</S.Title>
      {typeof subtitle === 'string' ? (
        <Subtitle>{subtitle}</Subtitle>
      ) : (
        subtitle
      )}
    </S.Spacer>
    {button}
  </Spacer>
);

export default NavigatableHeader;
